import {
  actualizarEvidencia,
  crearEvidencia,
  eliminarEvidencia,
  getEvidencias,
} from 'api/evidenciaCumplimiento'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'

const key = 'evidencias'
export function useObtenerEvidencia(buscar) {
  return useQuery(key, () => getEvidencias(buscar))
}

export function useCrearEvidencia() {
  const queryClient = useQueryClient()
  return useMutation(crearEvidencia, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarEvidencia() {
  const queryClient = useQueryClient()
  return useMutation(actualizarEvidencia, {
    onSuccess: (_, value) => {
      const { id, values: evidenciaActualizado } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((evidencia) => {
          let nuevoEvidencia = evidencia
          if (id === evidencia.id) {
            nuevoEvidencia = evidenciaActualizado
          }
          return nuevoEvidencia
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarEvidencia() {
  const queryClient = useQueryClient()
  return useMutation(eliminarEvidencia, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (evidencia) => evidencia.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useEvidencia(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarEvidencia } = useEliminarEvidencia()
  const { mutateAsync: actualizarEvidencia } = useActualizarEvidencia()
  const { mutateAsync: crearEvidencia } = useCrearEvidencia()

  async function handleCrearEvidencia(values, acciones) {
    try {
      const { data, onSuccessMessage } = await crearEvidencia(values)
      const message = `La evidencia ${data.nombre} fue creada satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  async function handleActualizarEvidencia({ id, values, acciones }) {
    try {
      const { data, onSuccessMessage } = await actualizarEvidencia({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'La evidencia fue actualizada satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  function handleEliminarEvidencia(id) {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarEvidencia(id)
          const message = `La evidencia ${data} fue eliminada satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  async function handleBuscarEvidencia(value) {
    queryClient.prefetchQuery(key, () => getEvidencias(value))
  }

  return {
    obtenerEvidencias: useObtenerEvidencia,
    handleEliminarEvidencia,
    handleActualizarEvidencia,
    handleCrearEvidencia,
    handleBuscarEvidencia,
  }
}
